


















































































import { Component, Vue } from 'vue-property-decorator';
import Axios from 'axios';
import { BillData, BillItemGroup, BillSettings } from '@/models/billData';
import { PeriodicBillResponse } from '@/models/periodicBillResponse';
import { Route } from 'vue-router';
import { BillStatusTypes } from '@/enums/billStatusTypes';
import { getGradeYearName } from '@/enums/gradeYears';
import moment from 'moment';
import BillEditor, { BillEditType } from '@/components/bill/billEditor.vue';
import { PaymentStatusTypes } from '@/enums/paymentStatusTypes';
import { BillItemsResponse } from '@/models/billItemResponse';
import * as billUtil from '@/utils/bill';
import AvaivaledVue from '@/components/avaivaled.vue';
import { FunctionTypes } from '@/enums/functionTypes';
import { CollectionAgencyTypes } from '@/enums/collectionAgencyTypes';

@Component({
  components: {
    BillEditor,
  },
})
export default class PeriodicBillDetail extends AvaivaledVue {
  get periodicBillId(): string {
    return this.$route.params.periodicBillId;
  }

  get pageTitle() {
    return '定期請求詳細';
  }

  get billed(): boolean {
    if (!this.billData) {
      return false;
    }
    return this.billData.billStatus === BillStatusTypes.Billed;
  }

  get billSettings(): BillSettings {
    return this.$store.state.bill.billSettings;
  }

  get billItemGroups(): BillItemGroup[] {
    return this.$store.state.bill.billItemGroups;
  }

  get collectionAgency(): CollectionAgencyTypes {
    if (!this.user || !this.user.collectionAgency) {
      return CollectionAgencyTypes.None;
    }
    return this.user.collectionAgency;
  }

  public BillEditType = BillEditType;

  public getGradeYearName = getGradeYearName;

  public billData: BillData | null = null;

  public async created() {
    const ok = await this.pageBackCheck(FunctionTypes.Bill);
    if (!ok) {
      return;
    }

    try {
      await this.$store.dispatch('bill/fetchBillSettings');
      await this.$store.dispatch('bill/fetchBillItems');
    } catch (error) {
      //
    }

    try {
      const res = await Axios.get<PeriodicBillResponse>(`/api/periodic-bills/${this.periodicBillId}`);
      const resData = res.data;
      this.billData = {
        billId: resData.periodicBillId,
        studentId: resData.studentId,
        studentUserId: resData.studentUserId,
        studentName: resData.studentName,
        gradeYear: resData.gradeYear,
        billGradeYear: resData.gradeYear,
        title: resData.title,
        billNo: resData.billNo,
        billDate: null,
        billDateCreationMonth: resData.billDateCreationMonth,
        billDateCreationDay: resData.billDateCreationDay,
        billMessage: resData.billMessage,
        contactInfo: resData.contactInfo,
        billType: resData.billType,
        billExplanation: resData.billExplanation,
        billLimitDate: null,
        billLimitDateCreationMonth: resData.billLimitDateCreationMonth,
        billLimitDateCreationDay: resData.billLimitDateCreationDay,
        taxRate: resData.taxRate,
        taxType: this.billSettings.taxType,
        taxRoundType: this.billSettings.taxRoundType,
        billStatus: BillStatusTypes.Unbilled,
        billStatusUpdatedAt: null,
        paymentStatus: PaymentStatusTypes.Unpaid,
        paymentStatusUpdatedAt: null,
        items: resData.periodicBillDetails.map((item) => ({
          isFree: false,
          groupType: item.groupType,
          groupName: '',
          itemId: item.itemId,
          itemName: '',
          unitPrice: 0,
          quantity: item.quantity,
          discountOfPercent: item.discountOfPercent,
          nonTaxable: item.nonTaxable,
        })),
        periodicBillId: null,
      };

      billUtil.refrectDetails(this.billItemGroups, this.billData!);
    } catch (error) {
      this.$router.push({ name: 'PeriodicBillList' });
      return;
    }
  }

  private deactivated() {
    this.$destroy();
  }

  private onCreateBill() {
    this.$router.push({ path: `/bill/bills/create?periodic-id=${this.periodicBillId}` });
  }

  private onQuoteBill() {
    this.$router.push({ path: `/bill/periodic-bills/create/${this.periodicBillId}` });
  }

  private onEditBill() {
    this.$router.push({ path: `/bill/periodic-bills/${this.periodicBillId}/edit` });
  }

  private async onDeleteBill() {
    try {
      await this.$confirm(
        '定期請求を削除します。よろしいですか？',
        '定期請求削除',
        {
          confirmButtonText: '削除',
          cancelButtonText: 'キャンセル',
          type: 'info',
        }
      );
    } catch (error) {
      return;
    }

    try {
      await Axios.delete(`/api/periodic-bills/${this.periodicBillId}`);

      this.$router.push({ name: 'PeriodicBillList' });

      this.$notify.success({
        title: '定期請求削除完了',
        message: '定期請求を削除しました。',
        position: 'bottom-right',
      });
    } catch (error) {
      this.$notify.error({
        title: '定期請求削除エラー',
        message:
          (error.response && error.response.data) || '定期請求の削除が失敗しました。',
        position: 'bottom-right',
      });
    }
  }
}
